import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const deleteUser = async (accountId: number, userId: number): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = `${BASE_URL}/${accountId}/user/${userId}`;

  return await axios.delete(finalURL, {
    headers: {
      'x-access-token': session?.accessToken,
    },
    timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      typeof AbortSignal.timeout !== 'undefined'
        ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
        : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
  }).then(() => {
    return;
  });
};
